import {Component, Prop, Watch, Emit, Vue} from 'vue-property-decorator';
import List from '@/assets/common/List/List.vue';
import WorkItemBulkModal from '../WorkItemBulkModal/WorkItemBulkModal.vue';
import { WorkItem } from '@/types';
import store from '@/assets/common/store/store';
@Component({
    components: {
        List,
        WorkItemBulkModal
    }
})
export default class WorkItemList extends Vue {
    private title = '作業項目';
    private baseUrl = '/work_items';
    private workItemId = '';

    @Prop()
    private workItems!: WorkItem[];

    @Prop()
    private withHidden!: boolean;

    @Prop()
    private id!: string;

    private get headerTitle() {
        return '新規作業項目';
    }


    @Emit('selectWorkItem')
    private setWorkItem(workItemId: string) {
        const filteredWorkItem = this.workItems.filter((item) => {
           return item.id === workItemId;
        });
        if(filteredWorkItem.length) {
            const selectedWorkItem: WorkItem = {
                  id: filteredWorkItem[0].id,
                  name: filteredWorkItem[0].name,
                  memo: filteredWorkItem[0].memo,
                  is_hidden: filteredWorkItem[0].is_hidden,
            };
           this.$router.push(`/master/work_items/${workItemId}`, () => {return});
            return selectedWorkItem;
        }
    }

    @Emit("openModal")
    private clickBulk() {
        return true;
    }

    @Emit("createWorkItem")
    private createWorkItem() {
        this.$router.push('/master/work_items', () => {return});
    }

    @Emit('checkboxChanged')
    private checkboxChanged(value: boolean) {
        return value;
    }


}